import React from 'react';
import PropTypes from 'prop-types';
import segment from '../analytics/segment';

const MainMenuItemsClickEventTracker = ({ items, children }) => {
  const {
    trackers: { trackEvent },
    constants: { events },
  } = segment;

  const itemsWithEventTracker = items.map((item) => {
    if (!item || !item.id || !item.onClick) return item;
    const originalClickAction = item.onClick;
    return {
      ...item,
      onClick: (event) => {
        originalClickAction(event);

        trackEvent(events.APP_MAIN_MENU_ITEM_CLICKED, {
          itemId: item.id,
        });
      },
    };
  });

  return React.cloneElement(children, { items: itemsWithEventTracker });
};

MainMenuItemsClickEventTracker.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default MainMenuItemsClickEventTracker;
